import './Home.css';

const Home = () => {
  return null
};

export default Home;
